export function retry(fn, total) {
  let time = 0;

  const wrapped = () => {
    time += 1;

    return fn().catch(err => {
      if (time > total) {
        throw err;
      }

      return wrapped();
    });
  };

  return wrapped();
}
